type AppEnv = "local" | "develop" | "staging01" | "prod";

export function getAppEnv(): AppEnv {
  return (import.meta.env.VITE_ENV || "local") as AppEnv;
}

export function isDevEnvironment(): boolean {
  const env = getAppEnv();
  return env === "local" || env === "develop";
}
